'use client';

import '../../styles/globals.css';
import { ValProvider } from '@valbuild/next';
import { ThemeProvider } from '../../context/ThemeContext';
import { config } from '../../val.config';
import { HeaderWithDarksideToggle } from '../../components/Header/Header';
import MainNav from '../../components/MainNav/MainNav';
import MobileNav from '../../components/MobileNav/MobileNav';
import Footer from '../../components/Footer/Footer';
import { useTheme } from '../../context/ThemeContext';
import Darkside from '../../components/Darkside/Darkside';
import { useEffect } from 'react';
import { kjoregarLogger } from '../../utils/kjoreGarLogger';
import ValModulesClient from '../(val)/ValModulesClient';

function AppContent({ children }: { children: React.ReactNode }) {
  const { theme } = useTheme();
  if (theme === 'darkside') {
    return <Darkside />;
  }
  return <>{children}</>;
}

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    kjoregarLogger();
  }, []);

  return (
    <html lang="nb">
      <head>
        <link rel="icon" href="/favicon.ico" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        <script
          defer
          data-domain="blank.no"
          src="https://plausible.io/js/plausible.js"
        ></script>
        <script
          id="pikwikScript"
          dangerouslySetInnerHTML={{
            __html: `
          (function(window, document, dataLayerName, id) {
          window[dataLayerName]=window[dataLayerName]||[],window[dataLayerName].push({start:(new Date).getTime(),event:"stg.start"});var scripts=document.getElementsByTagName('script')[0],tags=document.createElement('script');
          function stgCreateCookie(a,b,c){var d="";if(c){var e=new Date;e.setTime(e.getTime()+24*c*60*60*1e3),d="; expires="+e.toUTCString()}document.cookie=a+"="+b+d+"; path=/"}
          var isStgDebug=(window.location.href.match("stg_debug")||document.cookie.match("stg_debug"))&&!window.location.href.match("stg_disable_debug");stgCreateCookie("stg_debug",isStgDebug?1:"",isStgDebug?14:-1);
          var qP=[];dataLayerName!=="dataLayer"&&qP.push("data_layer_name="+dataLayerName),isStgDebug&&qP.push("stg_debug");var qPString=qP.length>0?("?"+qP.join("&")):"";
          tags.async=!0,tags.src="https://blank.containers.piwik.pro/"+id+".js"+qPString,scripts.parentNode.insertBefore(tags,scripts);
          !function(a,n,i){a[n]=a[n]||{};for(var c=0;c<i.length;c++)!function(i){a[n][i]=a[n][i]||{},a[n][i].api=a[n][i].api||function(){var a=[].slice.call(arguments,0);"string"==typeof a[0]&&window[dataLayerName].push({event:n+"."+i+":"+a[0],parameters:[].slice.call(arguments,1)})}}(i[c])}(window,"ppms",["tm","cm"]);
          })(window, document, 'dataLayer', 'c65bd7f9-3a21-42ed-8112-19e0034a2ea6');
          `,
          }}
        ></script>
        <link
          rel="preload"
          href="/fonts/PlakatGrotesk/PlakatGrotesk.otf"
          as="font"
          type="font/otf"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/BlankFraktur/BlankFraktur-Regular.otf"
          as="font"
          type="font/ttf"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/Respira/Respira-Black.otf"
          as="font"
          type="font/otf"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/Solina/Solina-CondensedMedium.otf"
          as="font"
          type="font/otf"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/Solina/Solina-CondensedSemiBold.otf"
          as="font"
          type="font/otf"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/Solina/Solina-Heavy.ttf"
          as="font"
          type="font/ttf"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/Solina/Solina-Light.ttf"
          as="font"
          type="font/ttf"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/WorkSans/WorkSans-Regular.ttf"
          as="font"
          type="font/ttf"
          crossOrigin=""
        />
        <link
          rel="preload"
          href="/fonts/WorkSans/WorkSans-Regular.ttf"
          as="font"
          type="font/ttf"
          crossOrigin=""
        />
        <meta
          name="google-site-verification"
          content="A2aeUh-6cwT17ZxWNIduvRwEJRSH4TTKXqG5ReSfoSY"
        />
      </head>
      <body id="root" className="root">
        <ValProvider config={config} suspend>
          <ValModulesClient />
          <ThemeProvider>
            <HeaderWithDarksideToggle>
              <MainNav />
              <MobileNav />
            </HeaderWithDarksideToggle>
            <AppContent>
              {children}
              <Footer />
            </AppContent>
          </ThemeProvider>
        </ValProvider>
      </body>
    </html>
  );
}
